// extracted by mini-css-extract-plugin
export default {"root":"ms8PYoVTLM","slider":"E_5JjCcYaO","toggle":"IEiEoCCbRB"};